'use strict';

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * IMPORTANT - This whole file needs to be REMOVED after all dependent sites are updated to utilize the latest refactor.
 * This is here for backwards compatibility.
 */

var constants = {
    common: {
        NOT_SET: '(not set)'
    },
    enhancedEcommerceEvents: {
        purchase: {
            STANDARD_MENU: 'Standard Menu',
            COMBO: 'Combo',
            ALACARTE: 'A la carte',
            DEFAULT_CURRENCY: 'USD'
        }
    },
    events: {
        offerRedemptionEvent: {
            DATALAYER_EVENT_VALUE: 'offerRedemption',
            OFFER_REDEMPTION: 'Offer Redemption',
            DIGITAL: 'Digital',
            MANUAL: 'Manual'
        }
    }
};

var DATALAYER_EVENT_VALUE = constants.events.offerRedemptionEvent.DATALAYER_EVENT_VALUE;
var OFFER_REDEMPTION = constants.events.offerRedemptionEvent.OFFER_REDEMPTION;
var DIGITAL = constants.events.offerRedemptionEvent.DIGITAL;
var MANUAL = constants.events.offerRedemptionEvent.MANUAL;

module.exports = function (options) {

    this.constants = constants;

    this.BaseGoogleAnalyticsEvent = function () {
        function _class(event, category, action, label) {
            _classCallCheck(this, _class);

            this.event = event;
            this.eventCategory = category;
            this.eventAction = action;
            this.eventLabel = label;
        }

        return _class;
    }();

    this.DigitalOfferRedemptionEvent = function (_BaseGoogleAnalyticsE) {
        _inherits(_class2, _BaseGoogleAnalyticsE);

        function _class2(offerTitle) {
            _classCallCheck(this, _class2);

            return _possibleConstructorReturn(this, _BaseGoogleAnalyticsE.call(this, DATALAYER_EVENT_VALUE, OFFER_REDEMPTION, DIGITAL, offerTitle));
        }

        return _class2;
    }(this.BaseGoogleAnalyticsEvent);

    this.ManualOfferRedemptionEvent = function (_BaseGoogleAnalyticsE2) {
        _inherits(_class3, _BaseGoogleAnalyticsE2);

        function _class3(offerTitle) {
            _classCallCheck(this, _class3);

            return _possibleConstructorReturn(this, _BaseGoogleAnalyticsE2.call(this, DATALAYER_EVENT_VALUE, OFFER_REDEMPTION, MANUAL, offerTitle));
        }

        return _class3;
    }(this.BaseGoogleAnalyticsEvent);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/analytics/GoogleTagManagerProvider.js
// module id = 857
// module chunks = 0